/*----------------------------------------------------------------------------------------------------
  This is the main javascript file for theme-specific scripts. This is (should be) the last .js
  file minified and loaded up in the theme, and should assume that all other dependencies (eg, jQuery)
  have been loaded already.
----------------------------------------------------------------------------------------------------*/
(function(){
	'use strict';
	var scroll = window.requestAnimationFrame ||
	             window.webkitRequestAnimationFrame ||
	             window.mozRequestAnimationFrame ||
	             window.msRequestAnimationFrame ||
	             window.oRequestAnimationFrame ||
	             function(callback){ window.setTimeout(callback, 1000/60) };
	var lastPosition = -1;
	function scrollFunction(){
		var top = window.pageYOffset;
		if( 0 < top ){
			document.body.classList.add( 'scrolled' );
		} else {
			document.body.classList.remove( 'scrolled' );
		}
	}
	function loop(){
		var top = window.pageYOffset;
		if( lastPosition == window.pageYOffset ){
			scroll(loop);
			return false;
		} else {
			lastPosition = window.pageYOffset;
			scrollFunction();
		}
		scroll(loop);
	}
	loop();

	function sameSizeBoxes(){
		var h = 0;
		var float = false;
		$( '.maxicourse-same-size' ).each( function(){
			$( this ).css({'height' : 'auto' });
			if( 'left' == $( this ).parent().css( 'float' ) ){
				float = true;
				h = Math.max( h, $( this ).height() );
			}
		} );
		if( float ){
			$( '.maxicourse-same-size' ).height( h + 'px' );
		}
	}

	$( document ).ready( function(){
		$( '#smaxicourse-tabs > ul > li > a' ).click(function(e){
			e.preventDefault()
			$(this).tab( 'show' );
		});
		sameSizeBoxes();
	});
	$( window ).resize(function(){
		sameSizeBoxes();
	});
})();